/** TextMesh resource slice: claims the type name. */
import { registerGenericResourceSlice } from '../../sliceRegistration.js';
registerGenericResourceSlice('textmesh', ['TextMesh']);
//# sourceMappingURL=index.js.map